import memoizeOne from 'react-utils/memoizeOne';
import { Metrics } from './metrics';
import { debug, round } from '../utils';
export const MetricEvents = {
  LOADED: 'component-loaded',
  READY: 'component-ready'
};
export const updateTimer = memoizeOne(({
  componentName,
  event,
  startTime
}) => {
  const endTime = performance.now();
  const timeDelta = endTime - startTime;
  Metrics.timer(event, {
    componentName
  }).update(round(timeDelta));
  debug(`Recording '${event}' event for '${componentName}':
      startTime=${round(startTime)}ms,
      endTime=${round(endTime)}ms,
      timeDelta=${round(timeDelta)}ms`);
  return {
    startTime,
    endTime,
    timeDelta
  };
});